import {useEffect, useRef, useState} from "react";
import {Button, Card, Col, message, Modal, Row, Space, Spin, Steps, Table, Upload} from "antd";
import {reconcile_img} from "../../../../AppImageConst";
import {DownloadOutlined, ExclamationCircleOutlined, InboxOutlined} from "@ant-design/icons";
import './style.scss';
import {
    MSG_ALLOWED_EXCEL_TYPES_ERROR,
    MSG_FAILED_TO_FETCH_BANK_TEMPLATES_ERROR,
    MSG_FAILED_TO_FETCH_NOT_RECONCILED_BANK_RECORD_LIST_ERROR,
    MSG_FAILED_TO_PREVIEW_EXCEL_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR,
    MSG_RECONCILIATION_PROCESS_FAILED,
    MSG_RECONCILIATION_PROCESS_SUCCESS,
    MSG_UPLOAD_BANK_EXCEL_WARN
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {ALLOWED_EXCEL, COMPONENT_TYPE, EMPTY_VALUE, RECONCILE_TYPES} from "../../../util/Constants";
import documentService from "../../../service/documentService";
import {toNumber} from "lodash";
import transactionService from "../../../service/transactionService";
import CustomerInvestRequestTableComp
    from "../../../components/admin/investReconciliation/customerInvestRequestTableComp";
import ReconciliationTableComp from "../../../components/admin/investReconciliation/reconciliationTableComp";
import {ReconciliationTableDataDto} from "../../../dto/admin/ReconciliationTableDataDto";
import transactionFetchService from "../../../service/transactionFetchService";
import modal from "antd/es/modal";

const {Dragger} = Upload;


const INVEST_BANK_EXCEL = "INVEST_BANK_EXCEL"

enum PAGE_STATUS {
    IN_PROGRESS = "In Progress",
    COMPLETED = "Completed",
    WAITING = "Waiting",
}

const InvestReconciliationPage = () => {
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;
    const [isSpinning, setSpinning] = useState(false);
    const [isPreviewSpinning, setPreviewSpinning] = useState(false);
    const [isOpenPreview, setOpenPreview] = useState(false);
    const [isSpinningCustomerInvestComp, setSpinningCustomerInvestComp] = useState(false);
    const [isSpinningReconciliationTableComp, setSpinningReconciliationTableComp] = useState(false);
    const [current, setCurrent] = useState(0);

    const [fileList, setFileList] = useState<any[]>([]);
    const [notReconciledRecordList, setNotReconciledRecordList] = useState<ReconciliationTableDataDto[]>([]);
    const [previewExcelList, setPreviewExcelList] = useState<ReconciliationTableDataDto[]>([]);
    const [uploadExcelPageStatus, setUploadExcelPageStatus] = useState<string>(PAGE_STATUS.IN_PROGRESS);
    const [reconciliationPageStatus, setReconciliationPageStatus] = useState<string>(PAGE_STATUS.WAITING);
    const [finalizationPageStatus, setFinalizationPageStatus] = useState<string>(PAGE_STATUS.WAITING);
    const [reconcileGroupNo, setReconcileGroupNo] = useState<number>(0);
    const childRef = useRef();


    const configs = {
        name: 'file',
        multiple: true,
        maxCount: 5,
        accept: ".xlsx, .xls"
    };


    useEffect(() => {


        const groupNo = localStorage.getItem("reconcileGroupNo");
        const reconcileStep = localStorage.getItem("reconcileStep");
        if (null != groupNo) {
            setReconcileGroupNo(toNumber(groupNo))
        }
        if (null != reconcileStep) {
            let steps = toNumber(reconcileStep);
            setCurrent(steps)
            setStepWiseStatus(steps, toNumber(groupNo))
        }

    }, []);

    const setStepWiseStatus = (step: number, reconcileGroupNo: number) => {
        if (1 == step) {
            setUploadExcelPageStatus(PAGE_STATUS.COMPLETED)
            setReconciliationPageStatus(PAGE_STATUS.IN_PROGRESS)
        } else if (2 == step) {
            setUploadExcelPageStatus(PAGE_STATUS.COMPLETED)
            setReconciliationPageStatus(PAGE_STATUS.COMPLETED)
            setFinalizationPageStatus(PAGE_STATUS.IN_PROGRESS)
            fetchNotReconciledBankRecords(reconcileGroupNo)
        }
    }

    const beforeUploadExcel = (file: any, fileList: any[]) => {
        let indexOf = ALLOWED_EXCEL.indexOf(file.type);
        if (indexOf < 0) {

            message.error(MSG_ALLOWED_EXCEL_TYPES_ERROR);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }
        setFileList(fileList => [...fileList, file])
        return false;

    };

    const onRemove = (file: any) => {
        const newFileList = fileList.filter(item => item.uid !== file.uid);
        setFileList(newFileList);

    };

    const onTemplateDownload = () => {
        setSpinning(true)
        documentService.fetchDocuments([INVEST_BANK_EXCEL]).then(res => {
            if (res.data !== null && res.data.results.length > 0) {
                let template = res.data.results[0];
                download(template.thumbB64, template.originalDocumentName)
                setSpinning(false)
            } else {
                setSpinning(false)
                message.error(MSG_FAILED_TO_FETCH_BANK_TEMPLATES_ERROR).then();
            }
        }, (reason) => {
            setSpinning(false)
            ErrorHandler.handleError(reason);
        })
    }

    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }

    const spinnerLoadReconcileComp = (spin: boolean) => {
        setSpinningReconciliationTableComp(spin)
    }

    const spinnerLoadInvestRequestComp = (spin: boolean) => {
        setSpinningCustomerInvestComp(spin)
    }
    const fetchNotReconciledBankRecords = (reconcileGroupNo: number) => {
        setSpinning(true)
        transactionFetchService.getReconciliationPendingBankDetails(reconcileGroupNo).then(res => {
            if (res.data !== null) {
                setNotReconciledRecordList(res.data.results)
                localStorage.setItem("reconcileStep", String(2))
                setCurrent(2);
                setReconciliationPageStatus(PAGE_STATUS.COMPLETED)
                setFinalizationPageStatus(PAGE_STATUS.IN_PROGRESS)
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_NOT_RECONCILED_BANK_RECORD_LIST_ERROR).then();
                setSpinning(false)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
    }

    const setPreviewClose = () => {
        setOpenPreview(false)
        setSpinning(false)
    }

    const excelPreviewColumns = [

        {
            title: 'Date',
            dataIndex: 'date',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : EMPTY_VALUE}</span>)
            }
        },
        {
            title: 'Portfolio ID',
            dataIndex: 'portFolioId',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : EMPTY_VALUE}</span>)
            }
        },
        {
            title: 'Fund',
            dataIndex: 'fund',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : EMPTY_VALUE}</span>)
            }
        },
        {
            title: 'Value',
            dataIndex: 'value',
            align: 'right',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? toFixed(text) : EMPTY_VALUE}</span>)
            }

        },
        {
            title: 'Collection Bank',
            dataIndex: 'collectionBank',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : EMPTY_VALUE}</span>)
            }
        },
        {
            title: 'Ref. No.',
            dataIndex: 'nic',
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : EMPTY_VALUE}</span>)
            }
        }

    ]

    const toFixed = (value: number | undefined): any => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }

    const steps = [
        {
            title: 'Upload Bank Excel',
            description: uploadExcelPageStatus,
            content: <><Row gutter={[16, 20]}>
                <CustomerInvestRequestTableComp cardSize={"large"} spinnerLoad={spinnerLoadInvestRequestComp}
                                                compType={COMPONENT_TYPE.ACTION} isCanShowRowSelection={false}
                                                isCanShowButton={true}/>
                <Col span={24}>
                    <Card title=' Upload Bank Excel'
                          extra={<Button type="primary" icon={<DownloadOutlined/>} onClick={onTemplateDownload}>Download
                              Template</Button>}>
                        <Dragger {...configs} beforeUpload={beforeUploadExcel} onRemove={onRemove}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined/>
                            </p>
                            <p className="ant-upload-text">Click or drag file(s) to this area to upload</p>
                            <p className="ant-upload-hint">
                                Support for multiple Excel file uploads
                            </p>
                        </Dragger>
                    </Card>
                </Col>
                <Modal title="Preview of Bank Excel"
                       open={isOpenPreview}
                       destroyOnClose={true}
                       maskClosable={false}
                       footer={null}
                       closable={false}
                       centered
                       width={1000}>

                    <Spin spinning={isPreviewSpinning}>
                        <Row className={"margin_top_20"}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Table scroll={{x: 'max-content'}} columns={excelPreviewColumns}
                                       dataSource={previewExcelList}/>
                                <Space style={{float: 'right'}}>
                                    <Button size={'large'} style={{width: 120}}
                                            onClick={setPreviewClose}>Re-Upload</Button>
                                    <Button size={'large'} style={{width: 120}} type="primary"
                                            onClick={() => onModalNext()}>Next</Button>
                                </Space>
                            </Col>
                        </Row>
                    </Spin>
                </Modal>

            </Row></>
        },
        {
            title: 'Reconciliation',
            description: reconciliationPageStatus,
            content: <>
                <Row gutter={[16, 20]}>
                    <Col span={24}>
                        <Card title='Auto Reconciled Transaction List'>
                            <ReconciliationTableComp key={1} spinnerLoad={spinnerLoadReconcileComp}
                                                     tableType={RECONCILE_TYPES.AUTO}
                                                     reconcileGroupNo={reconcileGroupNo}/>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title='Pending Transaction List'>
                            <ReconciliationTableComp key={2} spinnerLoad={spinnerLoadReconcileComp}
                                                     tableType={RECONCILE_TYPES.MANUAL}
                                                     reconcileGroupNo={reconcileGroupNo}/>
                        </Card>
                    </Col>
                </Row>


            </>
        },
        {
            title: 'Finalization',
            description: finalizationPageStatus,
            content: <>
                <Row gutter={[16, 20]}>
                    <Col span={24}>
                        <h3 style={{marginBottom: 0}} className={'h3-dark-mode-color'}>
                            Not Reconciled Transaction Records
                        </h3>
                    </Col>
                    <Col span={24}>
                        <Card title={'Bank Records'}>
                            <ReconciliationTableComp key={3} spinnerLoad={spinnerLoadReconcileComp}
                                                     tableType={RECONCILE_TYPES.MANUAL}
                                                     reconcileGroupNo={reconcileGroupNo}
                                                     isCanColumnHide={true}
                                                     notReconcileList={notReconciledRecordList}/>
                        </Card>
                    </Col>
                    <CustomerInvestRequestTableComp ref={childRef} cardSize={"large"}
                                                    spinnerLoad={spinnerLoadInvestRequestComp}
                                                    isCanShowAlert={true} isCanShowButton={false}
                                                    compType={COMPONENT_TYPE.ACTION} isCanShowRowSelection={true}/>
                </Row>
            </>
        },
    ];


    const onModalNext = () => {
        if (fileList.length > 0) {
            setSpinning(true)
            setPreviewSpinning(true)
            const formData = new FormData();
            fileList.forEach((file) => {
                formData.append('files', file);
            });
            transactionService.uploadExcelFiles(formData).then(res => {
                if (res.data !== null) {
                    let results = res.data.results;
                    let currentStep = current + 1;
                    let groupNo = results.reconcileGroupNo as number;

                    saveLocalStorage(currentStep, groupNo)
                    setReconcileGroupNo(groupNo)
                    setSpinning(false)
                    setPreviewSpinning(false)
                    setCurrent(currentStep);
                    setUploadExcelPageStatus(PAGE_STATUS.COMPLETED)
                    setReconciliationPageStatus(PAGE_STATUS.IN_PROGRESS)
                } else {
                    message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
                    setSpinning(false)
                    setPreviewSpinning(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
                setPreviewSpinning(false)
            })
        } else {
            message.warning(MSG_UPLOAD_BANK_EXCEL_WARN)
        }
    }
    const onNext = () => {
        fetchNotReconciledBankRecords(reconcileGroupNo)
    };

    const onPreview = () => {
        if (fileList.length > 0) {
            setSpinning(true)
            const formData = new FormData();
            fileList.forEach((file) => {
                formData.append('files', file);
            });
            transactionService.previewExcelFiles(formData).then(res => {
                if (res.data !== null) {
                    setPreviewExcelList(res.data.results)
                    setOpenPreview(true)
                } else {
                    message.error(MSG_FAILED_TO_PREVIEW_EXCEL_ERROR).then();
                    setSpinning(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        } else {
            message.warning(MSG_UPLOAD_BANK_EXCEL_WARN)
        }
    }

    const saveLocalStorage = (step: number, groupId: number) => {
        localStorage.setItem("reconcileStep", String(step))
        localStorage.setItem("reconcileGroupNo", String(groupId))
    }

    const onFinish = () => {

        let selectedIdList: number[] = (childRef?.current as any)?.getSelectedIdList();
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to finalize this reconciliation process?`,
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setSpinning(true)
                if (undefined == selectedIdList) {
                    selectedIdList = [];
                }
                transactionService.manualReconcileRejection(reconcileGroupNo, selectedIdList).then((res) => {
                    if (res.data.results) {
                        message.success(MSG_RECONCILIATION_PROCESS_SUCCESS)
                        setTimeout(() => {
                            setCurrent(0)
                            setFileList([])
                            localStorage.removeItem("reconcileStep");
                            localStorage.removeItem("reconcileGroupNo");
                            setOpenPreview(false)
                            setSpinning(false)
                        }, 1200)
                    } else {
                        message.error(MSG_RECONCILIATION_PROCESS_FAILED)
                        setSpinning(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setSpinning(false)

                })
            },
            onCancel() {

            }
        });

    }
    const items = steps.map((item) => ({key: item.title, title: item.title, description: item.description}));


    return (
        <Spin spinning={isSpinningReconciliationTableComp || isSpinningCustomerInvestComp || isSpinning}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'
                        style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div className='header_icon header-icon-center'>
                            <img style={{width:24,height:24}} src={reconcile_img} alt=""/>
                        </div>
                        Invest Reconciliation
                    </h2>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <Card className={'recon-step-card'}>
                        <Steps size={'small'} current={current} items={items}/>
                    </Card>
                </Col>
            </Row>

            <div className='margin_top_20'>
                {steps[current].content}
            </div>

            <Row gutter={[16, 20]} className='margin_top_20'>

                <Col span={24} className={'recon-btn-row'}>

                    {current == 0 && (
                        <Button size={'large'} type="primary" onClick={() => onPreview()}>Preview</Button>

                    )}
                    {current == 1 && (
                        <Button size={'large'} type="primary" onClick={() => onNext()}>Next</Button>
                    )}
                    {current === steps.length - 1 && (
                        <Button type="primary" size={'large'} onClick={() => onFinish()}>
                            Finalize
                        </Button>
                    )}
                </Col>
            </Row>
        </Spin>
    )
}
export default InvestReconciliationPage;
